import * as Yup from 'yup'
import { ACCEPT_FILES_IMAGES, ERRORS_MESSADGES } from '@/const'

const emailReg = /^[-\w.]+@([A-z0-9][-A-z0-9]+\.)+[A-z]{2,4}$/
// const passwordReg = /(?=.*[0-9])(?!.*[^\w\s])(?=.*[a-z])(?=.*[A-Z])/g
const latAndKirReg = /^[а-яА-ЯёЁa-zA-Z]+$/
const latKirDigReg = /^[а-яА-ЯёЁa-zA-Z0-9 ]+$/
const date = /(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19|20)\d\d/

const NullableAndRequired = Yup.string()
  .nullable()
  .required(ERRORS_MESSADGES.requireField)

const StringRequired = Yup.string().required(ERRORS_MESSADGES.requireField)

const StringRequiredMinMax = Yup.string()
  .required(ERRORS_MESSADGES.requireField)
  .min(3, ERRORS_MESSADGES.tooLessSimbols)
  .max(100, ERRORS_MESSADGES.tooMuchSimbols)

const StringNotRequiredMinMax = Yup.string()
  .max(1000, ERRORS_MESSADGES.tooMuchSimbols)
  .notRequired()

const Email = Yup.string()
  .nullable()
  .required(ERRORS_MESSADGES.requireField)
  .matches(emailReg, ERRORS_MESSADGES.uncorrectEmail)
  .email(ERRORS_MESSADGES.uncorrectEmail)
  .min(5, ERRORS_MESSADGES.tooLessSimbols)
  .max(254, ERRORS_MESSADGES.tooMuchSimbols)

const Password = Yup.string()
  .nullable()
  .required(ERRORS_MESSADGES.requireField)
  .min(8, ERRORS_MESSADGES.tooLessSimbols)
  .max(50, ERRORS_MESSADGES.tooMuchSimbols)
// .matches(passwordReg, ERRORS_MESSADGES.uncorrectPassword)

const ConfirmPassword = Yup.string()
  .nullable()
  .required(ERRORS_MESSADGES.requireField)
  .oneOf([Yup.ref('password'), null], ERRORS_MESSADGES.differentPasswords)
  .min(8, ERRORS_MESSADGES.tooLessSimbols)
  .max(50, ERRORS_MESSADGES.tooMuchSimbols)

const Name = Yup.string()
  .matches(latAndKirReg, ERRORS_MESSADGES.latAndKir)
  .required(ERRORS_MESSADGES.requireField)
  .nullable()
  .min(2, ERRORS_MESSADGES.tooLessSimbols)
  .max(250, ERRORS_MESSADGES.tooMuchSimbols)

// const LastName = Yup.string()
//   .matches(latAndKirReg, ERRORS_MESSADGES.latAndKir)
//   .max(250, ERRORS_MESSADGES.tooMuchSimbols)

// const School = Yup.string()
//   // .matches(latKirDigReg, ERRORS_MESSADGES.latAndKir)
//   .required(ERRORS_MESSADGES.requireField)
//   .nullable()
//   .min(2, ERRORS_MESSADGES.tooLessSimbols)
//   .max(250, ERRORS_MESSADGES.tooMuchSimbols)

const Date = Yup.string()
  .matches(date, ERRORS_MESSADGES.date)
  .required(ERRORS_MESSADGES.requireField)
  .nullable()

const Login = Yup.string()
  .matches(latKirDigReg, ERRORS_MESSADGES.latKirDig)
  .required(ERRORS_MESSADGES.requireField)
  .nullable()
  .min(3, ERRORS_MESSADGES.tooLessSimbols)

const File = Yup.mixed()
  .nullable()
  .required(ERRORS_MESSADGES.requireField)
  .test({
    message: ERRORS_MESSADGES.imageType,
    test: value => {
      return (
        value !== null &&
        value !== '' &&
        ACCEPT_FILES_IMAGES.includes(value.type)
      )
    }
  })

export const loginSchema = Yup.object().shape({
  login: NullableAndRequired,
  password: NullableAndRequired
})

export const resetPasswordSchema = Yup.object().shape({
  email: Email
})

export const tournamentRegistrationSchema = Yup.object().shape({
  email: Email,
  birthday: Date,
  state: StringRequired,
  city: StringRequired
})

export const resetPasswordSetPasswordSchema = Yup.object().shape({
  password: NullableAndRequired,
  password2: ConfirmPassword
})

export const registrationSchema = Yup.object().shape({
  login: Login,
  email: Email,
  password: Password,
  first_name: Name,
  // last_name: LastName,
  // uf_school: School,
  confirm_password: ConfirmPassword,
  personal_state: NullableAndRequired,
  personal_birthday: Date
})

export const profileInfoSchema = Yup.object().shape({
  login: Login,
  email: Email,
  name: Name,
  // last_name: LastName,
  // uf_school: School,
  personal_state: NullableAndRequired,
  personal_birthday: Date
})

export const championshipApplication = Yup.object().shape({
  title: StringRequired,
  jeka_version: StringRequired,
  school_name: StringRequired,
  locality: StringRequired,
  region: StringRequired,
  // class_name: StringRequired,
  email: Email,
  // stage: StringRequired,
  age: StringRequired,
  end_time: StringRequired
})

export const setPasswordSchema = Yup.object().shape({
  old_password: Password,
  password: Password,
  confirm_password: ConfirmPassword
})

export const feedbackSchema = Yup.object().shape({
  email: Email,
  question: StringRequired
})

export const addContestWork = Yup.object().shape({
  file: File,
  name: StringRequiredMinMax,
  description: StringNotRequiredMinMax
})
